// extracted by mini-css-extract-plugin
export default {"img":"Intro_img__VjkR2","swiper":"Intro_swiper__BH4Oq","navigation":"Intro_navigation__kUrr5"};